<template>
	<article class="inputInformation_page">
		<div class="separation_title"><span>请填写旅客信息</span></div>

		<section class="information_input">
			<div class="information_input_section">
				<span class="information_input_title">姓名</span>
				<input type="text" placeholder="请输入姓名" class="information_input_container" v-model="contactModel.RealName" />
			</div>
			<div class="information_input_section">
				<span class="information_input_title">手机号</span>
				<input type="tel" placeholder="请输入您的手机号码" class="information_input_container" v-model="contactModel.Mobile" />
			</div>
			<div class="information_input_section">
				<span class="information_input_title">证件类型</span>
				<input
					readonly="readonly"
					type=""
					placeholder="身份证"
					class="information_input_container idCard_type"
					v-model="contactModel.PapersType"
					@click="showPapersTypeChoose"
				/>
			</div>
			<div class="information_input_section">
				<span class="information_input_title">证件号</span>
				<input placeholder="请输入证件号码" class="information_input_container" v-model="contactModel.CardNO" />
			</div>

			<div class="information_input_section">
				<span class="information_input_title">出生日期[机票必填]</span>
				<input placeholder="请输入出生日期" class="information_input_container" v-model="contactModel.Birthday" type="date" />
			</div>

			<div class="selective_type_wrap">
				<label class="selective_type a_i_center" @click="sexChange('男')">
					<i :class="contactModel.Sex == '男' ? 'iconfont icon-xuanze primary_color' : 'iconfont icon-xuanze1 primary_color'"></i>
					<input type="radio" name="site" />
					<span>男</span>
				</label>
				<label class="selective_type a_i_center" @click="sexChange('女')">
					<i :class="contactModel.Sex == '女' ? 'iconfont icon-xuanze primary_color' : 'iconfont icon-xuanze1 primary_color'"></i>
					<input type="radio" name="site" />
					<span>女</span>
				</label>
			</div>

			<div class="btn_wrap big-btn"><button class="btn save_btn" @click="saveContact">保存</button></div>
		</section>
	</article>
</template>

<script>
import contactApi from '../request/contactApi';
import baseTool from '../utils/baseFunction';
export default {
	name: 'EditContact',
	data() {
		return {
			mode: '',
			id: '',
			contactModel: {},
			papersTypeArray: ['身份证', '护照', '回乡证', '户口本', '出生证', '其它']
		};
	},
	activated() {
		let that = this;
		this.contactModel = {};
		this.$nextTick(function() {
			that.mode = that.$route.params.mode;
			that.id = that.$route.params.id;
			if (that.mode == 'edit') {
				that.getContactModel();
			} else {
				let tmpModel = {
					UserID: 0,
					RealName: '',
					Mobile: '',
					PapersType: '身份证',
					CardNO: '',
					Sex: '男',
					Birthday: '',
					Status: true
				};
				that.contactModel = tmpModel;
			}
		});
	},
	methods: {
		idCardReading(idcard) {
			let that = this;
			let ageType, sex, birthday;
			if (idcard.length == 15) {
				let year = '19' + idcard.substr(6, 2);
				let month = idcard.substr(8, 2);
				let day = idcard.substr(10, 2);
				let orderCode = idcard.substr(12, 3);
				if (parseInt(orderCode) % 2 == 1) {
					sex = '男';
				} else {
					sex = '女';
				}
				birthday = year + '-' + month + '-' + day;
				this.contactModel.Birthday = birthday;
				this.contactModel.Sex = sex;
			} else if (idcard.length == 18) {
				let year = idcard.substr(6, 4);
				let month = idcard.substr(10, 2);
				let day = idcard.substr(12, 2);
				let orderCode = idcard.substr(14, 3);
				if (parseInt(orderCode) % 2 == 1) {
					sex = '男';
				} else {
					sex = '女';
				}
				birthday = year + '-' + month + '-' + day;
				this.contactModel.Birthday = birthday;
				this.contactModel.Sex = sex;
			}
		},
		getContactModel() {
			let that = this;
			this.$Spin.show();
			contactApi.getContactList(this.$store.state.user.OpenId, this.id).then(sucRes => {
				if (sucRes.success) {
					if (sucRes.data[0].Birthday && sucRes.data[0].Birthday != '') sucRes.data[0].Birthday = baseTool.formatDateStr(sucRes.data[0].Birthday);
					console.log(sucRes.data[0]);
					that.contactModel = sucRes.data[0];
				}
				that.$Spin.hide();
			});
		},
		saveContact() {
			let that = this;
			let model = this.contactModel;
			if (model.RealName == '' || model.CardNO == '' || model.Sex == '' || model.PapersType == '' || model.Mobile == '') {
				alert('请填写必要信息，作为上车出示证件的标准。');
			} 
      else if(model.Mobile.length < 8 || model.Mobile.length > 11){
        alert('手机号码长度错误,请校对。');
      }
      else {
				contactApi.updateContact(this.$store.state.user.OpenId, this.contactModel).then(sucRes => {
					if (sucRes.success) {
						this.$Message.success(sucRes.message);
						that.$router.go(-1);
					}
				});
			}
		},
		showPapersTypeChoose() {
			let that = this;
			let tmpArray = [];
			for (let i = 0; i < this.papersTypeArray.length; i++) {
				let tmp = {
					label: this.papersTypeArray[i],
					value: this.papersTypeArray[i]
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					that.contactModel.PapersType = result[0].value;
				}
			});
		},
		sexChange(val) {
			this.contactModel.Sex = val;
		}
	},
	watch: {
		'contactModel.CardNO': function(newval, oldval) {
			if (this.contactModel.PapersType == '身份证' && (newval.length == 15 || newval.length == 18)) {
				this.idCardReading(newval);
			}
		}
	}
};
</script>

<style lang="less" scoped="scoped">
@import '../style/public';

@primary-color: #006535;

.information_input {
	flex: 1;
	overflow: auto;
	border-top: 1px solid #888;
}
.information_input_section,
.selective_type_wrap {
	width: 90%;
	border-bottom: 1px solid #ddd;
}
.information_input_section {
	margin: 0.2rem auto 0;
	.flex_wrap(initial, initial, initial, column);
}
.selective_type_wrap {
	margin: 0 auto;
	.flex_wrap(initial, initial);
}
.information_input_title,
.information_input_container {
	/*line-height: 1rem;*/
	padding: 0.2rem;
	margin-left: 1em;
}
.information_input_title {
	color: #888;
}
.information_input_container {
	border: none;
	font-size: 0.4rem;
	color: @primary-color;
}
.information_input_container::-webkit-input-placeholder {
	letter-spacing: 2px;
	color: @primary-color;
}

.selective_type {
	flex: 0 0 20%;
	text-align: center;
	margin-left: 1em;
	line-height: 8vh;
	.flex_wrap(initial, center);
}

.site_lable,
.selective_type,
.pay_select_icon {
	position: relative;
	font-size: 0.4rem;
}
.site_lable > .iconfont,
.selective_type > .iconfont,
.pay_select_icon > .iconfont {
	font-size: 0.6rem;
	color: @primary-color;
	margin: 2px 5px 0 0;
}
.big-btn button{
    background-color: @primary-color;
    color: #fff;
    -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/EditContact.vue